import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';

import {PUBLIC_BASE_URL} from "@/config/env";


const index = () => import('@/page/index');//首页
const mine = () => import('@/page/mine/detail');//个人页面
const editorYourself = () => import('@/page/mine/editor');//个人编辑
const updateVip = () => import('@/page/mine/vip');//升级会员
const createBill = () => import('@/page/mine/bill');//订单页面
const partner = () => import("@/page/partner/detail");//成为合伙人
const targetSearch = () => import("@/page/target/search");//需求列表
const targetDetail = () => import("@/page/target/detail"); //需求详情
const targetMessage = () => import("@/page/target/message"); //需求详情(无需登录)
const createTarget = () => import("@/page/target/create"); //发布需求
const login = () => import('@/page/login');//登录
const common = () => import('@/page/common');//侧边栏

const people = () => import('@/page/people/search');
const peopleDetail = () => import('@/page/people/detail');
const createPeople = () => import('@/page/people/create');

const createSettle = () => import('@/page/people/settle');

Vue.use(Router);



let router = new Router({
	mode: "history",
	base: PUBLIC_BASE_URL,
	routes: [
		{ path: '*', redirect: '/people' },
		{ path: '', redirect: '/people' },
		{ path: '/', redirect: '/people' },

		{ path: '/login', name: 'login', component: login },

		{path: '/people', name: 'people', component: people},
    	{path: '/people/create', name: 'createPeople', component: createPeople},
    	{path: '/people/settle', name: 'createSettle', component: createSettle},
    	{path: '/people/:id', name: 'peopleDetail', component: peopleDetail},
        
        {path: '/mine', name: 'mine', component: mine},
        {path: '/mine/bill', name: 'bill', component: createBill},
        {path: '/mine/vip', name: 'vip', component: updateVip},
        {path: '/editor', name: 'editor', component: editorYourself},
        {path: '/partner', name: 'partner', component: partner},
        {path: '/target/search', name: 'targetSearch', component: targetSearch},
        {path: '/target/create', name: 'createTarget', component: createTarget},
        {path: '/target/:id', name: 'targetDetail', component: targetDetail},
        {path: '/targetmessage/:id', name: 'targetMessage', component: targetMessage},

	]
});

router.beforeEach(async (to,from,next)=>{
	/* console.log(to);
	console.log(from); */
	let {state={}} = store;
	let {userInfo = {}} = state;
	if (to.name == "login" || to.name == "createSettle" || to.name == "targetMessage") {
		next();
	}else{
		if(userInfo.id){
			if(userInfo.phone){
				next();
			}else{
				let r = encodeURIComponent(location.href);
				next("/login?t=bindphone&r="+r);
			}
		}else{
			await store.dispatch("getUserInfoAction");
			userInfo = state.userInfo;
			if(userInfo.id){
				if(userInfo.phone){
					next();
				}else{
					let r = encodeURIComponent(location.href);
					next("/login?t=bindphone&r="+r);
				}
			}else{
				let r = encodeURIComponent(location.href);
				next("/login?r="+r);
			}
		}
	}
});

export default router;





// WEBPACK FOOTER //
// ./src/router/index.js